import React from 'react';
import styled from 'styled-components';

interface Props {
	handleMarketingChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	marketingAllowed: boolean;
	narrowStyles: boolean;
}

const Wrapper = styled.div<{ narrowStyles: boolean }>`
	${(props) => (props.narrowStyles ? 'width: 18em;' : '')}
	margin: auto;
`;

const Header = styled.div<{ narrowStyles: boolean }>`
	font-size: 1.6em;
	${(props) => (props.narrowStyles ? 'text-align: center;' : '')}
	margin-bottom: 1em;
`;

const RadioButtonContainer = styled.div<{ narrowStyles: boolean }>`
	width: 100%;
	${(props) => (props.narrowStyles ? 'min-height: 10em;' : '')}
	//border: 1px solid red;
	margin-bottom: 0.2em;
	.button-holder {
		//border: 1px solid red;
		float: left;
		${(props) => (props.narrowStyles ? ' width: 20%;' : '')}
	}

	.regular-radio {
		display: none;
	}

	.regular-radio + label {
		-webkit-appearance: none;
		background-color: #fafafa;
		border: 1px solid #cacece;
		padding: 29px;
		border-radius: 50px;
		display: inline-block;
		position: relative;
	}

	.regular-radio:checked + label:after {
		content: ' ';
		width: 10px;
		height: 10px;
		border-radius: 50px;
		position: absolute;
		top: 3px;
		background: #99a1a7;
		left: 3px;
		font-size: 32px;
	}

	.regular-radio:checked + label {
		background-color: #e9ecee;
		color: #99a1a7;
		border: 1px solid #adb8c0;
	}

	.big-radio + label {
		padding: 12px;
	}

	.big-radio:checked + label:after {
		width: 16px;
		height: 16px;
		left: 4px;
		top: 4px;
	}

	.text-container {
		//border: 1px solid red;
		${(props) => (props.narrowStyles ? ' float: left;' : '')}
		width: 80%;
	}
`;

export const MarketingPermission: React.FC<Props> = (props: Props) => {
	return (
		<Wrapper narrowStyles={props.narrowStyles}>
			<Header narrowStyles={props.narrowStyles}>Markkinointilupa</Header>
			<RadioButtonContainer narrowStyles={props.narrowStyles}>
				<div className="button-holder">
					<input
						type="radio"
						id="radio-1-1"
						name="marketingPermission"
						className="regular-radio big-radio"
						value={'marketingAllowed'}
						onChange={props.handleMarketingChange}
						checked={props.marketingAllowed}
					/>
					<label htmlFor="radio-1-1" />
				</div>
				<div className={'text-container'}>JES! Haluan saada markkinointiviestejä Moin ja mahdollisten kumppaneiden palveluihin liittyen(Lupaamme että niitä tulee maksimissaan kerran kuussa</div>
			</RadioButtonContainer>
			<RadioButtonContainer narrowStyles={props.narrowStyles}>
				<div className="button-holder">
					<input
						type="radio"
						id="radio-1-2"
						name="marketingPermission"
						className="regular-radio big-radio"
						value={'marketingNotAllowed'}
						onChange={props.handleMarketingChange}
						checked={!props.marketingAllowed}
					/>
					<label htmlFor="radio-1-2" />
				</div>
				<div className={'text-container'}>VOI EIIII! En missään nimessä halua saada markkinointiviestejä Moin ja mahdollisten kumppaneiden palveluihin liittyen</div>
			</RadioButtonContainer>
		</Wrapper>
	);
};
